/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface ISONDNSEntry {
        ip: string;
        hostname: string;
        DNS?: string;
        VLAN?: number;
        name?: string;
        note?: string;
        routes?: string[];
        isIpRange: boolean;
        model?: string;
    }

    export interface ISONDnsMap {
        nodeName: string;
        fullName: string;
        entry: ISONDNSEntry;
        children: ISONDnsMap[];
        ipRange: string[];
        getFirstSignal?: () => ISONDNSEntry;
        findDataStreamIPs?: (prefix: string) => IIfaceIp[];
        isSignal?: (hostname: string) => boolean;
        findSignals: () => ISONDNSEntry[];
    }

    export interface IIfaceIp {
        interfaceNumber: number;
        ip: string;
    }

    export class SONDnsMap implements ISONDnsMap {
        public nodeName: string;
        public fullName: string;
        public entry: ISONDNSEntry;
        public children: ISONDnsMap[];
        public ipRange: string[];

        public static Empty(): SONDnsMap {
            return new SONDnsMap();
        }

        public static Copy(sonDnsMap: ISONDnsMap): SONDnsMap {
            const newSonDnsMap = new SONDnsMap();
            newSonDnsMap.nodeName = sonDnsMap.nodeName;
            newSonDnsMap.fullName = sonDnsMap.fullName;
            newSonDnsMap.entry = sonDnsMap.entry;
            newSonDnsMap.ipRange = sonDnsMap.ipRange;
            newSonDnsMap.children = sonDnsMap.children.map((sonDnsMap: ISONDnsMap) => this.Copy(sonDnsMap));
            return newSonDnsMap;
        }


        public static burnish(entries: Models.ISONDNSEntry[]): void {
            entries.forEach((entry: Models.ISONDNSEntry) => {
                entry.isIpRange = entry.ip.split("/")[1] !== "32";
            });
        }

        constructor(){}

        public getFirstSignal(): ISONDNSEntry {
            if (this.children.length === 0) {
                return this.entry;
            } else {
                return this.children[0].getFirstSignal();
            }
        }

        public findDataStreamIPs(prefix: string): IIfaceIp[] {
            let list: IIfaceIp[] = [];
            this.children.forEach( (child: ISONDnsMap) => {
                if (child.fullName.lastIndexOf(prefix, 0) > -1) {
                    const interfaceNumber: number = Number(child.fullName.substring(prefix.length, child.fullName.indexOf(".")));
                    if (interfaceNumber > 0) {
                        list[interfaceNumber - 1] = {
                            interfaceNumber: interfaceNumber,
                            ip: child.entry.ip.substring(0, child.entry.ip.indexOf("/")),
                        } as IIfaceIp;
                    }
                }
            });
            return list;
        }

        /**
         * We consider a hostname a signal if it starts with format "sXX.ifXX" such as
         * s03.if02.enc01a.wsht.ngs.
         * s01.if01.dec01a.gnve.ngs.
         * @param hostname
         */
        public isSignal(hostname: string): boolean {
            const match: string[] = hostname.match(/^s(..)\.if(..)/);
            return (match && match.length > 0 );
        }

        public findSignals(): Models.ISONDNSEntry[] {
            let signals: ISONDNSEntry[] = [];
            if (this.isSignal(this.fullName)) {
                signals.push(this.entry);
            }
            if (this.children.length > 0) {
                this.children.forEach((child: ISONDnsMap) => {
                    signals = signals.concat(child.findSignals());
                });
            }
            return signals;
        }
    }
}